import { DocumentPage, type DocumentSection } from "@/pages/DocumentPage";

const termsSections: DocumentSection[] = [
  {
    title: "투자 유의사항 및 AI 정보 제공 안내",
    body: "본 서비스에서 제공하는 모든 정보(AI 생성 콘텐츠 포함)는 단순 참고용이며, 어떠한 경우에도 투자 권유나 전문가의 자문을 대신할 수 없습니다.",
    items: [
      "인공지능(AI)이 제공하는 분석 및 답변은 기술적 한계로 인해 부정확하거나 편향된 정보를 포함할 수 있습니다.",
      "AI의 의견이나 분석 결과를 바탕으로 직접적인 투자를 결정해서는 안 됩니다.",
      "모든 투자 결정의 책임은 이용자 본인에게 있으며, 서비스는 투자 결과에 대해 어떠한 책임도 지지 않습니다.",
    ],
  },
  {
    title: "제 1 조 (목적)",
    body: "본 약관은 이용자가 앤트 서비스에서 제공하는 투자 정보 열람, 커뮤니티, 포트폴리오 관리 및 AI 비서 기능 등을 이용함에 있어 필요한 제반 사항을 규정함을 목적으로 합니다.",
  },
  {
    title: "제 2 조 (서비스의 내용)",
    body: "서비스는 이용자에게 다음과 같은 기능을 제공합니다.",
    items: [
      "시장 데이터 및 투자 관련 정보 제공",
      "AI 기반의 채팅 상담 및 정보 분석(Chat Assistant)",
      "커뮤니티 내 AI 자동 답변 및 참여(AI Mention)",
      "개인 포트폴리오 관리 및 자산 노출 분석",
      "이용자 간 정보 공유를 위한 커뮤니티 서비스",
    ],
  },
  {
    title: "제 3 조 (AI 서비스 이용 특칙)",
    items: [
      "서비스는 생성형 AI 기술을 활용하여 정보를 가공하고 제공합니다. AI는 실시간 시장 상황을 완벽하게 반영하지 못할 수 있으며, 환각 현상(Hallucination)으로 인해 사실과 다른 정보를 생성할 가능성이 있습니다.",
      "이용자는 AI가 제공한 정보를 반드시 신뢰할 수 있는 다른 출처를 통해 재확인해야 합니다.",
      "AI 기능을 악용하여 반복적인 부하를 주거나, 서비스의 운영을 방해하는 행위는 제한될 수 있습니다.",
    ],
  },
  {
    title: "제 4 조 (이용자의 의무)",
    items: [
      "이용자는 본인의 계정 정보를 타인에게 공유하거나 양도해서는 안 됩니다.",
      "커뮤니티 이용 시 타인의 권리를 침해하거나 욕설, 비방, 허위 사실 유포 등 건전한 소통을 저해하는 행위를 금지합니다.",
      "서비스 내의 정보를 무단으로 수집(크롤링 등)하거나 상업적으로 재배포하는 행위를 금지합니다.",
    ],
  },
  {
    title: "제 5 조 (책임의 제한)",
    items: [
      "서비스는 제공하는 정보의 정확성, 완전성, 신뢰성에 대해 보증하지 않습니다.",
      "천재지변, 디도스(DDoS) 공격, 서버 장애, 외부 API(거래소, 뉴스 등)의 오류 등 서비스의 통제 범위를 벗어난 사유로 발생한 손해에 대해서는 책임을 지지 않습니다.",
      "이용자 간의 분쟁이나 제3자와의 거래에서 발생한 문제에 대해 서비스는 개입하거나 책임지지 않습니다.",
    ],
  },
  {
    title: "제 6 조 (서비스의 변경 및 중단)",
    body: "서비스는 기술적 필요 또는 운영 정책에 따라 서비스의 일부 또는 전부를 수정, 중단할 수 있으며, 이 경우 사전에 서비스 내 공지사항을 통해 안내합니다.",
  },
  {
    title: "제 7 조 (문의 및 분쟁 해결)",
    body: "서비스 이용과 관련한 문의는 아래의 경로로 접수해 주시기 바랍니다.\n이메일: devggyul@gmail.com",
  },
];

export function TermsPage() {
  return (
    <DocumentPage
      eyebrow="Terms"
      title="이용약관"
      description={'본 약관은 앤트(이하 "서비스")가 제공하는 서비스의 이용과 관련하여 서비스와 이용자 간의 권리, 의무 및 책임사항을 정합니다.'}
      sections={termsSections}
      footer={"시행일: 2026년 4월 12일\n\n본 약관은 서비스 운영 상황에 따라 변경될 수 있으며, 이용자는 정기적으로 약관의 변경 사항을 확인해야 합니다."}
    />
  );
}
